import { memo, useCallback } from 'react';

import { PrivateAudioCodingsSelect } from '~/components/Filters/AudioCodingFilter/components/PrivateAudioCodingsSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard, type StringArrayFilterCardProps } from '~/components/Filters/StringArrayFilterCard';

type PrivateAudioCodingFilterCardProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseFilterCardProps;

export const PrivateAudioCodingFilterCard = memo(
  ({ boardId, libraryId, ...props }: PrivateAudioCodingFilterCardProps) => {
    const renderAudioCodingsSelect = useCallback<StringArrayFilterCardProps['StringSelect']>(
      (props) => <PrivateAudioCodingsSelect libraryId={libraryId} boardId={boardId} {...props} />,
      [boardId, libraryId],
    );

    return (
      <StringArrayFilterCard
        filter="audioCodings"
        filterCardType="audioCoding"
        StringSelect={renderAudioCodingsSelect}
        {...props}
      />
    );
  },
);

PrivateAudioCodingFilterCard.displayName = 'PrivateAudioCodingFilterCard';
